<mat-sidenav-container class="sidenav-container" autosize>
  @if (wediMewngofnodi()) {
    <mat-sidenav #sidenav [(mode)]="over" [(opened)]="opened" class="bottom-to-top {{ cssClass() }}">
      <div class="mat-sidenav-teitl" (click)="agorCauDewislen()" [class]="cssCefndirLogo()">
        @if (!wediCau) {
          <img alt="Asedau Fflyd" class="sidenav-logo" src="assets/lluniau/sidebar_logo.png" />
        }
        @if (wediCau) {
          <img alt="Asedau Fflyd" class="sidenav-fan" src="assets/lluniau/sidebar_fan.png" />
        }
      </div>

      @if (!wediCau) {
        <app-sidebar-dewislen></app-sidebar-dewislen>
      }
      @if (wediCau) {
        <div class="eicon-dewislen" (click)="agorCauDewislen()">
          <fa-icon icon="bars"></fa-icon>
        </div>
      }
      @if (!wediCau) {
        <app-hawlfraint></app-hawlfraint>
      }
    </mat-sidenav>
  }
  <mat-sidenav-content>
    <app-navbar class="navbar"></app-navbar>
    <div class="container-router-outlet">
      <app-rhybudd></app-rhybudd>
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
